

<template>
  <div id="app">

  <!-- <Intro v-if="introOpen"></Intro> -->

	<!-- asks to rotate device and enter full screen -->
  	<Playmode></Playmode> 

	<!-- Current game info -->
  	<div @click="openInv()" id="inventory">
  		<img src="assets/ui/menu.svg" alt="menu">
  	</div>

  	<!-- gameplay -->
  	<keep-alive>
  		<transition name="slideUpBig">
			 <component :is="currentView"></component>
		  </transition>>
	</keep-alive>

  <div class="darker"></div>

  </div>

</template>

<script>

import Intro from './components/Intro.vue'
import Quest from './components/Quest.vue'
import Inventory from './components/Inventory.vue'
import Menu from './components/Menu.vue'
import Playmode from './components/Playmode.vue'
import headful from 'headful'



headful({
    title: '9 Daemons: The begining of Apocalypse - Part 1',
    description: 'Play with 9-Daemons. Be good, evil or.. just lol. Game will choose its own narrative for you ❤🔥😂',
    keywords: 'Text adventure, quest, text, game, daemon, hell, heaven, angel, 18+',
    image: 'https://artrayd.com/9-daemons/og.jpg',
    lang: 'en',
    url: 'http://artrayd.com/9-daemons/'
});


require ('./css/quest.css')
require ('./css/playmode.css')
require ('./css/desktops.css')
require ('./css/inventory.css')
require ('./css/themes.css')
require ('./css/tictac.css')

export default {

  name: 'app',

  components: {
    Intro,
    Quest,
    Inventory,
    Menu,
    Playmode
  },

	data (){
		return {      
			currentView: 'Quest',
			inventoryShow: false,
      introOpen: true
		}
	},



	methods: {

		openInv(){
			if( !this.inventoryShow) {
				this.currentView = 'Inventory'
        // this.currentView = 'Menu'
				this.inventoryShow = true
				document.querySelector('#inventory img').classList.add('rotate180')
			} else {
				this.currentView = 'Quest'
				this.inventoryShow = false
				document.querySelector('#inventory img').classList.remove('rotate180')
			}
		},

    introOff(time){

      setTimeout(() => { 
        this.introOpen = false
      }, time)
    }
	},

  created: function (){

    // watching for store checkpoint, if it changes - load latest checkpoint
    this.$store.watch(
      (state)=>{ 
        return this.$store.state.checkpointLoad // could also put a Getter here
      },

      (newValue, oldValue)=>{

  		if(newValue == true){
  			this.openInv()		
  		}
    })

    this.introOff(7000)

  }


}
</script>